<template>
  <main id="main" class="main-site">
    <!-- Conteúdo -->
    <div class="container">
      <AlertCompletarCadastro v-if="session" :visible="situacaoCadastro == 1" :cnpj="session.DadosCliente.CliCiccgc"></AlertCompletarCadastro>
      <AlertCadastroNaoAtivo v-if="session" :visible="situacaoCadastro == 2"></AlertCadastroNaoAtivo>

      <div v-if="showModal" class="modal-overlay">
        <div class="modal-dialog">
          <div class="modal-content">
            <button type="button" @click="showModal = false">
              <i class="fa fa-close"></i>
            </button>
            <div class="modal-body">
              <img src="/assets/images/promocao-nordeste.png" alt="Promoção Nordeste" />
            </div>
          </div>
        </div>
      </div>

      <!-- Banners -->

      <ProductCarousel></ProductCarousel>

      <div class="wrap-top-banner-solar" v-if="homedestaquefixo.length > 0">
        <div class="wrap-show-advance-info-box style-1" style="margin: 20px 0">
          <div
            id="caroussel_ti"
            class="slide-carousel owl-carousel style-nav-1 caroussel_homepage"
            data-items="1"
            data-loop="1"
            data-nav="true"
            data-lazyload="true"
            data-slidespeed="1500"
            data-paginationSpeed="500"
            data-dots="false"
            data-autoplay="true"
          >
            <div v-for="(banner, index) in homedestaquefixo" :key="index" class="item-slide">
              <a
                :target="banner.Url.startsWith('http') ? '_blank' : '_self'"
                :href="
                  banner.Url.startsWith('http') ? banner.Url : `${$SiteUrl}/loja/${banner.Tipo === 'Campanha' ? 'campanhas' : 'marcas'}/${banner.Url}`
                "
              >
                BannerDestaque
                <img
                  :src="$imageUrl + '/Content/img/' + banner.Tipo + '/' + banner.ID + '/aldo40/' + banner.Banner"
                  :alt="banner.Alt"
                  :title="banner.Title"
                  class="img-slide"
                  width="330"
                  height="245"
                />
              </a>
            </div>
          </div>
        </div>
      </div>

      <div class="row-fluid blogAldoPage" style="justify-content: center; display: flex">
        <div class="row justify-content-center">
          <div class="col-md-12" style="margin-top: 25px">
            <div class="col-sm-3 col-md-3 divBlogMinHeight" v-for="(post, index) in postBlogAldo" :key="index">
              <a rel="noreferrer" :href="`${post.link}`" target="_blank">
                <div class="post">
                  <div class="post-img-content">
                    <img :src="hasThumbnail(post)" :title="post.title.rendered" :alt="post.title.rendered" class="img-responsive homeAldo" />
                  </div>
                  <div class="content">
                    <h2 v-html="post.title.rendered"></h2>
                    <div v-html="post.excerpt.rendered"></div>
                  </div>
                </div>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-top-banner-solar">
        <div class="wrap-show-advance-info-box style-1" style="margin: 20px 0">
          <div
            id="caroussel_solar"
            class="slide-carousel owl-carousel style-nav-1 caroussel_homepage"
            data-items="1"
            data-loop="1"
            data-slidespeed="1500"
            data-paginationSpeed="500"
            data-nav="true"
            data-dots="false"
            data-autoplay="true"
          >
            <div v-for="(banner, index) in bannerSolarRotativo" :key="index" class="item-slide">
              <h3 data-v-9f6cbee6="" class="title-box">Aldo Solar</h3>
              <a
                :target="banner.Url.startsWith('http') ? '_blank' : '_self'"
                :href="
                  banner.Url.startsWith('http') ? banner.Url : `${$SiteUrl}/loja/${banner.Tipo === 'Campanha' ? 'campanhas' : 'marcas'}/${banner.Url}`
                "
              >
                Banner
                <img
                  :src="$imageUrl + '/Content/img/' + banner.Tipo + '/' + banner.ID + '/aldo40/' + banner.Banner"
                  :title="banner.Title"
                  :alt="banner.Alt"
                  class="img-slide"
                  width="330"
                  height="245"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-top-banner-solar">
        <div class="wrap-show-advance-info-box style-1" style="margin: 20px 0">
          <div
            id="caroussel_ultimos2"
            class="slide-carousel owl-carousel style-nav-1 caroussel_homepage"
            data-items="1"
            data-loop="1"
            data-nav="true"
            data-slidespeed="1500"
            data-lazyload="true"
            data-paginationSpeed="500"
            data-dots="false"
            data-autoplay="true"
          >
            <div v-for="(banner, index) in bannerultimos2" :key="index" class="item-slide">
              <a
                :target="banner.Url.startsWith('http') ? '_blank' : '_self'"
                :href="
                  banner.Url.startsWith('http') ? banner.Url : `${$SiteUrl}/loja/${banner.Tipo === 'Campanha' ? 'campanhas' : 'marcas'}/${banner.Url}`
                "
              >
                Banner2
                <img
                  :src="$imageUrl + '/Content/img/' + banner.Tipo + '/' + banner.ID + '/aldo40/' + banner.Banner"
                  :title="banner.Title"
                  :alt="banner.Alt"
                  class="img-slide"
                  width="330"
                  height="245"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-top-banner-solar">
        <div class="wrap-show-advance-info-box style-1" style="margin: 20px 0">
          <div
            id="caroussel_ti"
            class="slide-carousel owl-carousel style-nav-1 caroussel_homepage"
            data-items="1"
            data-loop="1"
            data-nav="true"
            data-lazyload="true"
            data-slidespeed="1500"
            data-paginationSpeed="500"
            data-dots="false"
            data-autoplay="true"
          >
            <div v-for="(banner, index) in bannerTIRotativo" :key="index" class="item-slide">
              <a
                :target="banner.Url.startsWith('http') ? '_blank' : '_self'"
                :href="
                  banner.Url.startsWith('http') ? banner.Url : `${$SiteUrl}/loja/${banner.Tipo === 'Campanha' ? 'campanhas' : 'marcas'}/${banner.Url}`
                "
              >
                BannerTI
                <h3 data-v-9f6cbee6="" class="title-box">Aldo TI</h3>
                <img
                  :src="$imageUrl + '/Content/img/' + banner.Tipo + '/' + banner.ID + '/aldo40/' + banner.Banner"
                  :alt="banner.Alt"
                  :title="banner.Title"
                  class="img-slide"
                  width="330"
                  height="245"
                />
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="wrap-top-banner-solar">
        <div class="wrap-show-advance-info-box style-1" style="margin: 20px 0">
          <div>
            <div class="item-slide">
              <h3 class="title-box texto_google">
                <a style="color: white" target="_blank" href="http://g.page/aldo.solar/review?gm"
                  >Avalia&ccedil;&otilde;es - Deixe-nos um coment&aacute;rio</a
                >
              </h3>
              <div class="row">
                <div class="col-md-2" id="div1_google">
                  <div data-romw-token="KBB6JhJ0eRKya2bElpy857mw2OPjCdyjUxyalkEVxqsmRXPUR2"></div>
                </div>
                <div class="col-md-9" id="div2_google" style="padding-top: 45px">
                  <div data-romw-token="VPFtMHaePLJxXvXhwEKcMN85faChzFamqpffUonSjATZzfAMDD"></div>
                </div>
              </div>
              <script defer src="https://reviewsonmywebsite.com/js/v2/embed.js?id=aff5ead23f27558cf238" type="application/javascript"></script>
            </div>
          </div>
        </div>
      </div>
    </div>
    <HomeBanner></HomeBanner>
  </main>
</template>

<script>
import axios from 'axios'
import AlertCompletarCadastro from '../components/partials/AlertCompletarCadastro'
import AlertCadastroNaoAtivo from '../components/partials/AlertCadastroNaoAtivo'
import ProductCarousel from '../components/partials/ProductCarousel'
import RenderSlider from '../Utils/RenderSlider'
import HomeBanner from '../components/partials/HomeBanner'

export default {
  name: 'Homepage',
  created: function () {
    try {
      const self = this
      const session = JSON.parse(localStorage.getItem('usuarioLogado'))

      axios
        .get(`${this.$apiUrl}Marketing.svc/gethomemarketing`)
        .then((response) => {
          if (response.data) {
            let respSolar = response.data.find((element) => element.Name == 'getCampanhaMarcaBannerHomeSolar')
            let respTI = response.data.find((element) => element.Name == 'getCampanhaMarcaBannerHomeTI')
            let respUltimos2 = response.data.find((element) => element.Name == 'getCampanhaMarcaBannerHomeUltimos2')
            let resphomedestaquefixo = response.data.find((element) => element.Name == 'getBannerDestaqueFixo')
            if (respSolar.JSON.length > 0) {
              self.bannerSolarRotativo = respSolar.JSON
            }
            if (respTI.JSON.length > 0) {
              self.bannerTIRotativo = respTI.JSON
            }
            if (respUltimos2.JSON.length > 0) {
              self.bannerultimos2 = respUltimos2.JSON
            }
            if (resphomedestaquefixo.JSON.length > 0) {
              self.homedestaquefixo = resphomedestaquefixo.JSON
            }

            setTimeout(function () {
              RenderSlider('.caroussel_homepage')
            }, 400)
            self.vshowImgTop = true
          }
        })
        .catch((e) => {})
      const _selfCalculadora = this

      if (session != null) {
        if (session.DadosCliente.TipoUsuario == 2) {
          _selfCalculadora.calcLink = `${_selfCalculadora.$SiteUrl}/calculadora-aldo-solar/gestao/dashboard`
          _selfCalculadora.calcName = 'Calculadora Aldo Solar'
        } else {
          _selfCalculadora.calcLink = `${_selfCalculadora.$SiteUrl}/calculadora-aldo-solar/revenda/dashboard`
          _selfCalculadora.calcName = 'Calculadora Aldo Solar'
        }
      }

      axios.get(self.$mktUrl + '/PAGEMOTOR.ASMX/getParametro?nmParametro=PARAMETROBLOGHOME').then((responseParametro) => {
        let xmlparametro = new window.DOMParser().parseFromString(responseParametro.data, 'text/xml')
        let tagsparametro = xmlparametro.getElementsByTagName('string')[0].innerHTML
        var strPostID = ''
        let quantidadeImagens = 0
        tagsparametro.split(',').forEach(function (item) {
          if (quantidadeImagens > 3) return
          strPostID += '&include[]=' + item
          quantidadeImagens++
        })
        this.loadBlog(strPostID)
      })
    } catch (err) {
      console.log(err)
    }
  },
  components: {
    AlertCompletarCadastro,
    AlertCadastroNaoAtivo,
    ProductCarousel,
    HomeBanner
  },
  data() {
    return {
      calcLink: 'https://calculadorasolar.aldo.com.br/',
      calcName: 'Calculadora Solar',
      bannerSolarRotativo: [],
      bannerTIRotativo: [],
      postBlogAldo: [],
      postBlogAldoDestaque: [],
      renderpostBlog: false,
      bannerultimos2: [],
      countdownProducts: [],
      homedestaquefixo: [],
      surpriseRender: true,
      session: null,
      situacaoCadastro: 0,
      showModal: false
    }
  },

  props: {
    msg: String
  },

  mounted() {
    const logon = localStorage.getItem('usuarioLogado')
    if (logon) {
      this.session = JSON.parse(logon)
      this.situacaoCadastro = this.session.DadosCliente.SituacaoCadastro
      this.checkNordeste()
    }
  },
  metaInfo() {
    const _self = this
    let strDescription =
      'Fabricante e Distribuidora Oficial exclusivamente para revendedor, integrador e instalador TI, Energia Solar e Drone.  Entrega rápida e segura. Cadastre-se e comece a vender.'
    let strtitle = 'Aldo Solar - Maior Distribuidor de Energia Solar do Brasil'
    var url = 'https://www.aldo.com.br'
    url = '0; url=' + url
    if (localStorage.getItem('usuarioLogado') === null && localStorage.getItem('waitingLogin') === null) {
      return {
        meta: [{ 'http-equiv': 'refresh', content: url }]
      }
    } else {
      return {
        title: strtitle,
        meta: [
          { name: 'description', content: strDescription },
          { name: 'twitter:card', content: strDescription },
          { name: 'twitter:title', content: strtitle },
          { name: 'twitter:description', content: strDescription },
          // image must be an absolute path
          { name: 'twitter:image', content: 'https://www.aldo.com.br/assets/images/logo-top-1.png' },
          // Facebook OpenGraph
          { property: 'og:title', content: strtitle },
          { property: 'og:site_name', content: 'Aldo Solar' },
          { property: 'og:locale', content: 'pt_BR' },
          { property: 'og:type', content: 'website' },
          { property: 'og:image', content: 'https://www.aldo.com.br/assets/images/logo-top-1.png' },
          { property: 'og:description', content: strDescription }
        ],
        link: [{ rel: 'canonical', href: `https://www.aldo.com.br/` }]
      }
    }
  },
  methods: {
    banner: function (id, name, img, url) {
      this.id = id
      this.name = name
      this.img = img
      this.url = url
    },
    loadBlog: async function (strPostID) {
      var strLink = 'https://www.aldo.com.br/blog/wp-json/wp/v2/posts?_embed' + strPostID + '&orderby=include'
      const self = this
      axios
        .get(strLink)
        .then((response) => {
          self.postBlogAldo = response.data
          self.renderpostBlog = true
        })
        .catch((e) => {
          self.renderpostBlog = false
        })
    },
    hasThumbnail: function (post) {
      if (
        post._embedded['wp:featuredmedia'] &&
        post._embedded['wp:featuredmedia'][0].media_details &&
        post._embedded['wp:featuredmedia'][0].media_details.sizes
      ) {
        return post._embedded['wp:featuredmedia'][0].media_details.sizes.medium.source_url
      }
    },
    hasThumbnailDestaque: function (post) {
      if (
        post._embedded['wp:featuredmedia'] &&
        post._embedded['wp:featuredmedia'][0].media_details &&
        post._embedded['wp:featuredmedia'][0].media_details.sizes
      ) {
        return post._embedded['wp:featuredmedia'][0].media_details.sizes.medium_large.source_url
      }
    },
      checkNordeste: function () {
      var estado = this.session && this.session.DadosCliente ? this.session.DadosCliente.EstUf : null
      var estadosNordeste = ['MA', 'PI', 'CE', 'RN', 'PB', 'PE', 'AL', 'SE', 'BA']
      if (estado && estadosNordeste.includes(estado)) {
        this.showModal = true
        return true
      }
      return false
    }
  }
}
</script>

<style scoped>
.description-category {
  margin-left: 10px;
  margin-right: 10px;
  margin-top: 15px;
}

.post {
  background-color: #fff;
  overflow: hidden;
  min-height: 310px;
  box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.1), 0 1px 2px 0 rgba(0, 0, 0, 0.06);
}

.post .content {
  padding: 15px;
}

.post .author {
  font-size: 11px;
  color: #737373;
  padding: 25px 30px 20px;
}

.post .post-img-content {
  height: 140px;
  position: relative;
}

.post .post-img-content img {
  position: absolute;
}

.post .post-title {
  display: table-cell;
  vertical-align: bottom;
  z-index: 2;
  position: relative;
}

.post .post-title b {
  background-color: rgba(51, 51, 51, 0.58);
  display: inline-block;
  margin-bottom: 5px;
  color: #fff;
  padding: 10px 15px;
  margin-top: 5px;
}

img.img-responsive.homeAldo {
  width: 260px;
}

.divBlogMinHeight {
  min-height: 320px;
}

.post p {
  color: black;
  font-size: 11px;
}

.widget.widget-image {
  overflow: hidden;
  max-height: 300px;
}

.widget {
  border: none;
  box-shadow: 0 2px 0 rgba(0, 0, 0, 0.07);
  -webkit-border-radius: 5px;
  -moz-border-radius: 5px;
  border-radius: 5px;
  margin-bottom: 20px;
  position: relative;
  background: #fff;
  padding: 20px;
  display: block;
}

.widget-image-cover {
  margin: -20px;
  padding: 100% 20px 20px;
  border-radius: 5px;
  overflow: hidden;
  background: #3c454d;
  position: relative;
}

.widget-image:hover .widget-image-cover img {
  -webkit-transform: scale(1.3);
  -ms-transform: scale(1.3);
  transform: scale(1.3);
}

.widget-image .widget-image-cover img {
  transition: all 0.1s ease-in-out;
}

.widget-image-cover img {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  max-width: 100%;
}

.widget-image-info {
  position: absolute;
  bottom: 0;
  left: 0;
  right: 0;
  background: linear-gradient(to bottom, rgba(0, 0, 0, 0) 0, rgba(0, 0, 0, 0.8) 75%);
  padding: 20px;
  color: #fff;
  font-weight: bold;
}

.widget-image-info h5 {
  color: #fff;
  margin-top: 0;
  margin-bottom: 5px;
  font-size: 22px;
  font-weight: bold;
}

.widget-image-info p {
  color: rgba(255, 255, 255, 0.9);
}

.row {
  margin: 0 -10px;
}

.row > [class*='col-'] {
  padding: 0 10px;
}

.widget-image-user .widget-image-user-image {
  border-radius: 36px;
  float: left;
  width: 36px;
  background: #fff;
}

.widget-image-user .widget-image-user-info {
  margin-left: 46px;
}

.widget-image-user .widget-image-user-image img {
  max-width: 100%;
  border-radius: 36px;
}

.container.bootstrap.snippets.bootdey {
  margin-top: 20px;
}

.modal-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  z-index: 9998;
}

.modal-dialog {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  z-index: 9999;
}

.modal-body img {
  display: block;
  max-width: 100%;
}
</style>
